export default __webpack_public_path__ + "static/media/webineer.81556e1f.png";